<template>
  <SpIphone>
    <div class="content">
      <el-row v-if="form.text_msg">
        <el-col :span="5">
          <div class="left">
            <el-avatar
              class="avatar"
              shape="square"
              :size="24"
              icon="el-icon-user-solid"
            />
          </div>
        </el-col>
        <el-col :span="19">
          <div class="right">
            <div class="bubbles text-bubbles">
              <div class="text_msg">
                {{ form.text_msg }}
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
      <template v-for="(item, index) in form.attachments">
        <el-row :key="index">
          <el-col :span="5">
            <div class="left">
              <el-avatar
                class="avatar"
                shape="square"
                :size="24"
                icon="el-icon-user-solid"
              />
            </div>
          </el-col>

          <el-col :span="19">
            <div class="right">
              <div v-if="item.msgtype === 'image'">
                <img
                  class="upload-pic"
                  :src="item.image.pic_url"
                  alt=""
                >
              </div>
              <div
                v-if="item.msgtype === 'link'"
                class="bubbles link"
              >
                <span class="link-title">{{ item.link.title }}</span>
                <div class="h5-link">
                  <div class="link-name">
                    {{ item.link.url }}
                  </div>
                  <img
                    class="link-pic"
                    :src="item.link.picurl"
                    alt=""
                  >
                </div>
              </div>
              <div
                v-if="item.msgtype === 'miniprogram'"
                class="bubbles program"
              >
                <span class="program-title">{{ item.miniprogram.title }}</span>
                <img
                  class="program-pic"
                  :src="item.miniprogram.img_url"
                  alt=""
                >
                <div class="program-tips">
                  <img
                    src="@/assets/img/wechat.png"
                    alt=""
                  >
                  小程序
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </template>
    </div>
  </SpIphone>
</template>

<script>
export default {
  name: 'IphoneContent',
  props: {
    form: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      key: 1
    }
  },
  watch: {
    // form (newVal) {
    //   console.log(newVal, 'newVal9999')
    // }
  }
}
</script>

<style lang="scss" scoped>
.content {
  ::v-deep {
    .el-row {
      margin-bottom: 6px;
    }
  }
  .left {
    .avatar {
      background-color: rgb(68, 143, 247);
    }
  }
  .right {
    .upload-pic {
      display: block;
      width: 110px;
      height: 80px;
      background-color: #333;
    }

    .bubbles {
      .text_msg {
        word-wrap: break-all;
      }
      font-size: 12px;
      padding: 6px 8px;
      border-radius: 2px;
      display: inline-block;
      background-color: #fff;
      position: relative;
      padding: 2px 6px;
      line-height: 20px;

      &::after {
        content: ' ';
        position: absolute;
        left: -5px;
        top: 8px;

        width: 0;
        height: 0;
        border-top: 3px solid transparent;
        border-right: 6px solid #fff;
        border-bottom: 3px solid transparent;
      }
    }
    .text-bubbles {
      width: 100%;
      overflow-wrap: break-word;
    }
    .link {
      .link-title {
        color: #999;
        font-size: 12px;
      }
      .h5-link {
        display: flex;
        color: #999;
        margin-top: 4px;
        .link-name {
          width: 80px;
          word-wrap: break-word;
          line-height: 15px;
          font-size: 12px;
          margin-right: 2px;
        }
        .link-pic {
          width: 30px;
          height: 30px;
        }
      }
    }

    .program {
      .program-pic {
        display: block;
        width: 110px;
        height: 80px;
        background-color: #333;
      }
      .program-tips {
        margin-top: 5px;
        border-top: 1px solid #dcdfe6;
        font-size: 12px;
        img {
          display: inline;
          width: 10px;
          height: 10px;
        }
      }
    }
  }
}
</style>
